export default [{
  path: '/view/relatorio-contrato/:id',
  name: 'relatoriocontrato',
  component: () => import('@/shared/components/relatorio-contrato/RelatorioContrato.vue'),
  meta: {
    requiredAuth: true,
    action: 'auditar',
    layout: 'full',
  },
}]
